import { render, staticRenderFns } from "./materialMain.vue?vue&type=template&id=34c7628d&"
import script from "./materialMain.vue?vue&type=script&lang=ts&"
export * from "./materialMain.vue?vue&type=script&lang=ts&"
import style0 from "./materialMain.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports